import { MapControl } from 'components/UI/FormUI';
import { EditSelectedLinkPageTemplate } from './EditSelectedLinkEditTemplate';
import MultipleMapSelector from '../RegionSelection/MapVersion/MultipleMapSelector';
import RoadCoverage from '../RoadCoverage/RoadCoverage';
import { SelectedLinkRegionSelector } from './SelectedLinkRegionSelector';
import { useMenu } from 'reducers/menuReducer';
import { EmptyPlaceholder } from 'components/UI/EmptyPlaceholder';
import { FormGroup } from 'tombac';
import {
  MAX_SELECTED_LINK_REGION_AREA,
  SelectedLinkRegionSettings,
} from './SelectedLinkRegionSettings';
import { useMemo, useState } from 'react';
import { calculateArea } from '../RegionSelection/areaValidation';
import { useValidation } from 'hooks/useValidation';
import {
  nameRequirements,
  selectedLinkRegionRequirements,
} from '../Requirements/requirements';
import { regionOutside } from '../RegionSelection/validation';
import LimitsApi from 'api/LimitsApi';
import { useRoadCoverage } from 'hooks/useRoadCoverage';
import { AnalysisType } from 'model/AnalysisDto';

interface Props {
  resetSelectorType: VoidFunction;
}

export const RegionSelectorPage = ({ resetSelectorType }: Props) => {
  const [menu] = useMenu();
  const [intersectionsPointsNumber, setIntersectionsPointsNumber] = useState(0);
  const regionArea = useMemo(() => calculateArea(menu.regions), [menu.regions]);
  const limits = LimitsApi.use();
  const [showRadius, setShowRadius] = useState(false);
  const [bufferRadiusInKilometers, setBufferRadiusInKilometers] = useState(
    menu.bufferRadiusInKilometers,
  );

  const coverage = useRoadCoverage({
    regions: menu.regions,
    type: AnalysisType.SelectedLink,
    mapType: menu.mapType,
    mapVersion: menu.mapVersion,
    bufferRadiusInKilometers: menu.bufferRadiusInKilometers,
  });


  const validation = useValidation(
    [
      ...selectedLinkRegionRequirements,
      ...nameRequirements,
      {
        label: `Region does not intersect any road segment with selected road classes`,
        check: () => intersectionsPointsNumber === 0,
      },
      // {
      //   label:
      //     'Regions area exceeded the report limit. Edit regions to see length of pricing coverage',
      //   check: () => coverage.limitExceeded,
      // },
      {
        label: `Region area exceeds ${MAX_SELECTED_LINK_REGION_AREA} km²`,
        check: () => regionArea > MAX_SELECTED_LINK_REGION_AREA,
      },
      {
        label: `Region is outside allowed area`,
        check: () => {
          if (limits?.limits?.allowedArea === undefined) return false;

          const someLinkIsOutside =
            menu.regions.find((it) =>
              regionOutside(it, limits.limits.allowedArea),
            ) !== undefined;

          return someLinkIsOutside;
        },
      },
    ],
    { menu },
    () => { },
  );

  const isRegionSelected = menu.regions.length > 0;

  return (
    <EditSelectedLinkPageTemplate
      validation={validation}
      asideSection={
        isRegionSelected ? (
          <FormGroup>
            <SelectedLinkRegionSettings
              regionArea={regionArea}
              showRadius={showRadius}
              setShowRadius={setShowRadius}
            />
          </FormGroup>
        ) : (
          <EmptyPlaceholder
            type="linkRegion"
            subtitle="Click to select first point and draw region"
          />
        )
      }
      links={menu.links}
      glMapSection={
        <>
          <MapControl style={{ bottom: '0px' }}>
            <MultipleMapSelector />
          </MapControl>
          <RoadCoverage coverage={coverage} regions={menu.regions} />
          <SelectedLinkRegionSelector
            setIntersectionsPointsNumber={setIntersectionsPointsNumber}
            resetSelectorType={resetSelectorType}
            showRadius={showRadius}
            bufferRadiusInKilometers={bufferRadiusInKilometers}
          />
        </>
      }
    />
  );
};
